import { Entity } from '../../entities/entity';
import { TenantSubscription } from '../../entities/tenant/tenant';
import { TenantPlan } from '../tenant.plan';

import Enumerable from 'linq';
import { BaseSecurityModule } from '../base.security.module';
import { AIAgentSecurityModule } from '../modules/ai.agent.security.module';
import { AppSecurityModule, AppSecurityRight } from '../modules/app.security';
import { ConfigurationSecurityModule, ConfigurationSecurityRight, ConfigurationSubModule } from '../modules/configuration.security.module';
import { FinanceSecurityModule } from '../modules/finance.security.module';
import { InboundEmailSecurityModule } from '../modules/inbound.email.security.module';
import { IndividualComplianceSecurityModule, IndividualComplianceSecurityRight } from '../modules/individual.compliance.security.module';
import { IntegrationSecurityModule } from '../modules/integration.security.module';
import { JobSecurityModule } from '../modules/job.security.module';
import { MobileTechniciansSecurityModule, MobileTechniciansSecurityRight } from '../modules/mobile.technicians.security.module';
import { QuoteSecurityModule } from '../modules/quote.security.module';
import { SchedulerSecurityModule } from '../modules/scheduler.security.module';
import { TimesheetSecurityModule } from '../modules/timesheet.security.module';
import { WorkComplianceSecurityModule, WorkComplianceSecurityRight } from '../modules/work.compliance.security.module';
import { PortalClientSecurityModule } from '../modules/portal.clients.security.module';
import { PortalContractorSecurityModule } from '../modules/portal.contractors.security.module';
import { ClaimSecurityModule } from '../modules/claim.security.module';
import { CommandCenterSecurityModule } from '../modules/command.center.security.module';
import { CrmSecurityModule, CrmSecurityRight } from '../modules/crm.security.module';
import { ReportSecurityModule } from '../modules/report.security.module';
import { VariationSecurityModule } from '../modules/variation.security.module';
import { AssetSecurityModule } from '../modules/asset.security.module';
import { DefectSecurityModule } from '../modules/defect.security.module';
import { RecurringJobSecurityModule } from '../modules/recurring.job.security.module';
import { TaskSecurityModule } from '../modules/task.security.module';
import { JobTemplatesSecurityModule, JobTemplateSecurityRight } from '../modules/job.template.security.module';
import { SalesSecurityModule } from '../modules/sales.security.module';
import { DashboardSecurityModule } from '../modules/dashboard.security.module';
import { QuoteTemplatesSecurityModule } from '../modules/quote.template.security.module';
import { ProjectJobsSecurityModule } from '../modules/project.jobs.security.module';
import { MultiStageJobsSecurityModule } from '../modules/multi.stage.jobs.security.module';
import { AddressValidationSecurityModule } from '../modules/address.validation.security.module';
import { EnterpriseSearchSecurityModule } from '../modules/enterprise.search.security.module';
import { PropertyManagementSecurityModule } from '../modules/property.management.security.module';
import { WorkBuddyConnectSecurityModule } from '../modules/workbuddy.connect.security.module';
import { EquipmentSecurityModule } from '../modules/equipment.security.module';
import { LocationSecurityModule } from '../modules/location.security.module';
import { FormSecurityModule, FormSecurityRight } from '../modules/form.security.module';
import { SecurityModule, SecurityModuleName } from '../security.module';

export class SecurityModuleUtility {

    public static systemModules: BaseSecurityModule<any>[] = [
        new AppSecurityModule(),
        new QuoteSecurityModule(),
        new TimesheetSecurityModule(),
        new TaskSecurityModule(),
        new IndividualComplianceSecurityModule(),
        new ConfigurationSecurityModule(),
        new FinanceSecurityModule(),
        new InboundEmailSecurityModule(),
        new SchedulerSecurityModule(),
        new CrmSecurityModule(),
        // new PurchaseOrderSecurityModule(),
        new WorkComplianceSecurityModule(),
        new MobileTechniciansSecurityModule(),
        new PortalClientSecurityModule(),
        new PortalContractorSecurityModule(),
        new ClaimSecurityModule(),
        new CommandCenterSecurityModule(),
        new ReportSecurityModule(),
        new VariationSecurityModule(),
        new DefectSecurityModule(),
        new AssetSecurityModule(),
        new RecurringJobSecurityModule(),
        new JobTemplatesSecurityModule(),
        new QuoteTemplatesSecurityModule(),
        new SalesSecurityModule(),
        new DashboardSecurityModule(),
        new FormSecurityModule(),
        new ProjectJobsSecurityModule(),
        new MultiStageJobsSecurityModule(),
        new JobSecurityModule(),
        new AddressValidationSecurityModule(),
        new EnterpriseSearchSecurityModule(),
        new PropertyManagementSecurityModule(),
        new WorkBuddyConnectSecurityModule(),
        new EquipmentSecurityModule(),
        new LocationSecurityModule(),
        new AIAgentSecurityModule(),
        new IntegrationSecurityModule(),
    ];

    public static getConfigurationSubAccessModules(rights: number[]): ConfigurationSubModule[] {

        if (!rights?.length) return [];

        const modules: ConfigurationSubModule[] = [];

        Enumerable.from(rights).forEach(x => {

            switch (x) {
                case ConfigurationSecurityRight.AccessPricing:
                    modules.push(ConfigurationSubModule.Pricing);
                    break;

                case ConfigurationSecurityRight.AccessMetadata:
                    modules.push(ConfigurationSubModule.Metadata);
                    break;

                case ConfigurationSecurityRight.AccessTemplates:
                    modules.push(ConfigurationSubModule.Templates);
                    break;
                case ConfigurationSecurityRight.AccessTenancy:
                    modules.push(ConfigurationSubModule.Tenancy);
                    break;
                case ConfigurationSecurityRight.AccessBilling:
                    modules.push(ConfigurationSubModule.TenancyBilling);
                    break;
                case ConfigurationSecurityRight.ManageBilling:
                    modules.push(ConfigurationSubModule.TenancyBilling);
                    break;
                case CrmSecurityRight.ManageSecurityRoles:
                    modules.push(ConfigurationSubModule.Security);
                    break;
                // case UserSecurityRight.CanAccess:
                //     modules.push(ConfigurationSubModule.User);
                //     break;
                // case UserSecurityRight.ManageSecurityRole:
                //     modules.push(ConfigurationSubModule.Security);
                //     break;

                case IndividualComplianceSecurityRight.ManageComplianceRules:
                    modules.push(ConfigurationSubModule.IndividualCompliance);
                    break;

                case WorkComplianceSecurityRight.ManageComplianceRules:
                    modules.push(ConfigurationSubModule.WorkCompliance);
                    break;

                default:
                    break;


            }
        });

        return modules;
    }

    public static getModuleById(moduleId: string): SecurityModule<any> {

        const selectedModule = Enumerable.from(SecurityModuleUtility.systemModules)
            .firstOrDefault(x => x._id === moduleId);

        return selectedModule;

    }

    public static getPlanModules(): Entity[] {

        return Enumerable
            .from(SecurityModuleUtility.systemModules)
            .where(x => x.plan !== TenantSubscription.System)
            .select(x => {
                return {
                    _id: x._id,
                    name: x.name,
                    data: x.plan
                } as Entity;
            })
            .orderBy(x => x.name)
            .toArray();
    }

    public static getPlanRightsMask(plan: TenantPlan): number[] {

        const disabledRights: number[] = [];

        if (!plan) return disabledRights;

        const moduleRights = Enumerable
            .from(SecurityModuleUtility.systemModules)
            .where(x => x.plan !== TenantSubscription.System)
            .toDictionary(x => x._id, x => x.allRights);

        const disabledModules = this.getPlanDisabledModules(plan);

        Enumerable
            .from(disabledModules)
            .forEach(disabledId => {
                if (!moduleRights.contains(disabledId)) return;
                disabledRights.push(...moduleRights.get(disabledId));
            });

        if (disabledModules.includes(SecurityModuleName.PortalContractors))
            disabledRights.push(AppSecurityRight.LoginContractor);

        if (disabledModules.includes(SecurityModuleName.PortalClients))
            disabledRights.push(AppSecurityRight.LoginClient);

        if (disabledModules.includes(SecurityModuleName.Assets)) {
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobManageAssets);
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewAssets);
        }

        if (disabledModules.includes(SecurityModuleName.Tasks))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewTasks);

        if (disabledModules.includes(SecurityModuleName.Defects))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewDefects)

        if (disabledModules.includes(SecurityModuleName.Finance))
            disabledRights.push(MobileTechniciansSecurityRight.ManageJobViewInvoices)

        switch (plan.subscription) {
            case TenantSubscription.Core:
                disabledRights.push(AppSecurityRight.LoginManager);
                disabledRights.push(JobTemplateSecurityRight.CanAccess, JobTemplateSecurityRight.Manage);
                disabledRights.push(FormSecurityRight.CanAccessForms, FormSecurityRight.CreateEditForms, FormSecurityRight.DeleteForms, FormSecurityRight.ModifyAfterSubmission);
                disabledRights.push(MobileTechniciansSecurityRight.ManagePurchaseOrders, MobileTechniciansSecurityRight.CanAccessPurchaseOrders);
                break;

            case TenantSubscription.Professional:
                break;

            case TenantSubscription.Enterprise:
                break;

        }

        return disabledRights;
    }

    public static getPlanDisabledModules(plan: TenantPlan): string[] {

        if (!plan) return [];

        const disabledFeatures = Enumerable
            .from(Object.keys(plan.features))
            .where(featureKey => !plan.features[featureKey])
            .toArray();

        const disabledAddons = Enumerable
            .from(Object.keys(plan.addons))
            .where(featureKey => !plan.addons[featureKey])
            .toArray();

        const disabledModules = [...disabledFeatures, ...disabledAddons];

        return disabledModules;
    }


}
